import { Link } from "react-router-dom";

const entries = [
  {
    type: "movie",
    title: "电影频道",
    desc: "科幻 / 悬疑 / 动作 / 爱情",
    icon: "ri-film-line",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20film%20genre%20illustration%2C%20vintage%20projector%20and%20film%20reels%20with%20glowing%20light%20beams%2C%20deep%20green%20and%20warm%20amber%20tones%2C%20minimal%20elegant%20composition%2C%20soft%20gradient%20background%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=entry-movie&orientation=landscape",
  },
  {
    type: "series",
    title: "电视剧频道",
    desc: "都市 / 古装 / 医疗 / 武侠",
    icon: "ri-tv-2-line",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20tv%20drama%20genre%20illustration%2C%20retro%20television%20set%20emitting%20warm%20glow%20in%20a%20dark%20cozy%20room%2C%20deep%20green%20and%20amber%20tones%2C%20minimal%20elegant%20composition%2C%20soft%20gradient%20background%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=entry-series&orientation=landscape",
  },
  {
    type: "variety",
    title: "综艺频道",
    desc: "真人秀 / 音乐 / 美食 / 竞技",
    icon: "ri-mic-line",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20variety%20show%20genre%20illustration%2C%20stage%20microphone%20and%20colorful%20spotlights%20with%20confetti%2C%20deep%20green%20and%20bright%20orange%20tones%2C%20minimal%20elegant%20composition%2C%20soft%20gradient%20background%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=entry-variety&orientation=landscape",
  },
];

export default function CategoryEntry() {
  return (
    <section className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
      {entries.map((entry) => (
        <Link
          key={entry.type}
          to={`/category/${entry.type}`}
          className="group relative block h-40 md:h-44 rounded-lg overflow-hidden border border-background-200/70 cursor-pointer"
        >
          <img
            src={entry.image}
            alt={`${entry.title}入口`}
            title={`进入${entry.title}浏览高清影视内容`}
            className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-background-50/95 via-background-50/70 to-background-50/20" />
          <div className="relative z-10 h-full flex items-center gap-4 px-5 md:px-6">
            <span className="w-12 h-12 rounded-lg bg-primary-500/20 border border-primary-500/40 flex items-center justify-center shrink-0">
              <i className={`${entry.icon} text-2xl text-primary-300`} />
            </span>
            <div>
              <h3 className="font-heading text-lg font-bold text-foreground-950 group-hover:text-primary-300 transition-colors">
                {entry.title}
              </h3>
              <p className="text-xs text-foreground-600 mt-1">{entry.desc}</p>
            </div>
            <i className="ri-arrow-right-line ml-auto text-foreground-500 group-hover:text-primary-300 group-hover:translate-x-1 transition-all" />
          </div>
        </Link>
      ))}
    </section>
  );
}